export interface VideoItem {
  id: number;
  title: string;
  category: string;
  duration: string;
  views: string;
  date: string;
  hot?: boolean;
  cover: string;
  description: string;
}

export const categories: string[] = [
  "全部",
  "娱乐八卦",
  "社会热点",
  "明星现场",
  "生活趣事",
  "萌宠日常",
  "街头采访",
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "当红歌手演唱会彩排被拍，台下互动太有爱",
    category: "明星现场",
    duration: "03:24",
    views: "128.6万",
    date: "08-18",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Live%20concert%20stage%20with%20colorful%20spotlights%20and%20singer%20silhouette%2C%20energetic%20crowd%20at%20night%2C%20vibrant%20warm%20coral%20and%20amber%20stage%20lighting%2C%20modern%20music%20show%20atmosphere&width=800&height=450&seq=video-cover-01&orientation=landscape",
    description: "现场视频记录当红歌手彩排时的真实瞬间，台下互动与演唱花絮全收录。",
  },
  {
    id: 2,
    title: "网红探店爆火街区，排队两小时值不值？",
    category: "生活趣事",
    duration: "05:12",
    views: "89.3万",
    date: "08-18",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Busy%20street%20food%20stall%20with%20warm%20evening%20light%20and%20crowd%20waiting%20in%20line%2C%20steaming%20delicious%20snacks%2C%20cozy%20urban%20night%20market%20vibe%2C%20candid%20documentary%20style%20photography&width=800&height=450&seq=video-cover-02&orientation=landscape",
    description: "跟着网红走进爆火街区，实拍排队实况与真实味道测评，带你避雷又种草。",
  },
  {
    id: 3,
    title: "小区门口偶遇萌宠二哈，拆家现场被抓包",
    category: "萌宠日常",
    duration: "02:45",
    views: "215.0万",
    date: "08-17",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Cute%20playful%20husky%20dog%20in%20sunny%20residential%20garden%2C%20happy%20expression%2C%20warm%20natural%20daylight%2C%20lovable%20pet%20photography%2C%20bright%20cheerful%20atmosphere&width=800&height=450&seq=video-cover-03&orientation=landscape",
    description: "萌宠二哈的日常欢乐实录，拆家被抓包的可爱瞬间萌翻全场。",
  },
  {
    id: 4,
    title: "街头随机采访：你最想对十年前的自己说什么？",
    category: "街头采访",
    duration: "06:40",
    views: "56.8万",
    date: "08-17",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Street%20interview%20scene%20with%20young%20people%20talking%20to%20camera%20in%20city%20plaza%2C%20natural%20evening%20lighting%2C%20casual%20urban%20lifestyle%2C%20warm%20tones%2C%20documentary%20style&width=800&height=450&seq=video-cover-04&orientation=landscape",
    description: "街头随机采访路人，听听那些关于青春与遗憾的真实心里话。",
  },
  {
    id: 5,
    title: "最新剧集首映礼现场直击，主演阵容全阵容亮相",
    category: "娱乐八卦",
    duration: "08:15",
    views: "342.0万",
    date: "08-16",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Red%20carpet%20premiere%20event%20with%20celebrities%20and%20flashing%20cameras%20at%20night%2C%20glamorous%20warm%20stage%20lights%2C%20excited%20press%20photographers%2C%20entertainment%20news%20atmosphere&width=800&height=450&seq=video-cover-05&orientation=landscape",
    description: "新剧首映礼现场全记录，红毯花絮与主演采访不容错过。",
  },
  {
    id: 6,
    title: "暴雨中坚守岗位的暖心一幕，路人纷纷点赞",
    category: "社会热点",
    duration: "01:58",
    views: "98.2万",
    date: "08-16",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20with%20a%20worker%20helping%20pedestrians%20under%20an%20umbrella%2C%20heartwarming%20scene%2C%20soft%20warm%20street%20lamps%20reflecting%20on%20wet%20ground%2C%20touching%20documentary%20photography&width=800&height=450&seq=video-cover-06&orientation=landscape",
    description: "暴雨天气里的暖心瞬间，普通人的善意让整座城市都温暖起来。",
  },
  {
    id: 7,
    title: "网友自制料理翻车合集，笑到肚子疼",
    category: "生活趣事",
    duration: "04:30",
    views: "167.9万",
    date: "08-15",
    cover: "https://readdy.ai/api/search-image?query=Funny%20kitchen%20cooking%20fail%20moment%20with%20colorful%20ingredients%20and%20steam%2C%20playful%20bright%20kitchen%20with%20warm%20lighting%2C%20comedy%20lifestyle%20photography%2C%20vibrant%20and%20amusing&width=800&height=450&seq=video-cover-07&orientation=landscape",
    description: "网友分享的厨房翻车名场面合集，快乐源泉持续在线。",
  },
  {
    id: 8,
    title: "萌宠短视频挑战赛，谁家毛孩子最会整活",
    category: "萌宠日常",
    duration: "03:05",
    views: "77.4万",
    date: "08-15",
    cover: "https://readdy.ai/api/search-image?query=Adorable%20fluffy%20kitten%20playing%20with%20a%20small%20toy%20on%20a%20warm%20sunny%20windowsill%2C%20soft%20golden%20light%2C%20cute%20pet%20photography%2C%20cozy%20and%20playful&width=800&height=450&seq=video-cover-08&orientation=landscape",
    description: "全网萌宠整活大挑战，看看各家毛孩子的才艺大比拼。",
  },
  {
    id: 9,
    title: "商业街新店开业排长龙，究竟靠什么火出圈",
    category: "社会热点",
    duration: "05:48",
    views: "63.1万",
    date: "08-14",
    cover: "https://readdy.ai/api/search-image?query=Modern%20commercial%20street%20with%20a%20new%20shop%20grand%20opening%20and%20long%20queue%20of%20shoppers%2C%20bright%20daylight%2C%20vibrant%20urban%20retail%20scene%2C%20lively%20commercial%20photography&width=800&height=450&seq=video-cover-09&orientation=landscape",
    description: "实地探访爆火新店，分析它凭什么在开业当天就排起长队。",
  },
  {
    id: 10,
    title: "音乐节现场氛围感拉满，全场大合唱太震撼",
    category: "明星现场",
    duration: "07:20",
    views: "203.5万",
    date: "08-14",
    cover: "https://readdy.ai/api/search-image?query=Open%20air%20music%20festival%20at%20dusk%20with%20large%20crowd%20singing%20together%20under%20colorful%20lights%2C%20festival%20atmosphere%2C%20warm%20orange%20and%20pink%20sky%2C%20energetic%20and%20joyful&width=800&height=450&seq=video-cover-10&orientation=landscape",
    description: "户外音乐节现场实录，万人合唱的震撼瞬间气氛直接拉满。",
  },
  {
    id: 11,
    title: "深夜食堂探店，人均五十吃到扶墙走",
    category: "生活趣事",
    duration: "06:12",
    views: "45.9万",
    date: "08-13",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20restaurant%20interior%20with%20delicious%20food%20on%20table%20and%20warm%20ambient%20lamps%2C%20appetizing%20cuisine%20photography%2C%20intimate%20dining%20atmosphere&width=800&height=450&seq=video-cover-11&orientation=landscape",
    description: "深夜食堂探店记录，人均五十就能吃撑的宝藏小店推荐。",
  },
  {
    id: 12,
    title: "街头艺人大展身手，围观路人直呼太厉害",
    category: "街头采访",
    duration: "04:05",
    views: "81.7万",
    date: "08-12",
    cover: "https://readdy.ai/api/search-image?query=Street%20performer%20showing%20amazing%20talent%20with%20crowd%20watching%20in%20a%20city%20square%2C%20evening%20warm%20lights%2C%20lively%20public%20performance%20scene%2C%20captivating%20street%20photography&width=800&height=450&seq=video-cover-12&orientation=landscape",
    description: "街头艺人的高能表演现场，围观的观众直呼太厉害了。",
  },
];